import React from "react";
import {Box, Divider, Stack, Typography} from "@mui/material";
import {formatDateISO} from "../../utils/helpers";

export default function BookingLogs({logs}) {
    return (
        <Box sx={{width: "calc(100% - 32px)", mx: "auto", my: 2}}>
            <Divider sx={{mt: 2, mb: 1}}/>

            <Typography variant="subtitle1" fontWeight="bold" sx={{mb: 1}}>
                Historique des actions
            </Typography>

            <Box sx={{maxHeight: 200, overflowY: "auto"}}>
                {logs && logs.length > 0 ? (
                    <Stack spacing={1}>
                        {logs.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((log) => (
                            <Box key={log.id} sx={{border: "1px solid #ccc", borderRadius: 1, p: 1}}>
                                <Typography variant="body2" color="text.secondary">
                                    {formatDateISO(log.timestamp.replace('Z', ''))} - {log.message}
                                </Typography>
                            </Box>
                        ))}
                    </Stack>
                ) : (
                    <Typography variant="body2" color="text.secondary">Aucun log disponible.</Typography>
                )}
            </Box>
        </Box>
    );
}
